export enum AssetType {
  DOCUMENT = 'document',
  IMAGE = 'image',
  MODEL = 'model',
  MANIFEST = 'manifest',
  SCAN = 'scan',
  SCENE = 'scene',
  MOLD = 'mold',
}

/**
 * Semantic 3D asset types that callers may explicitly select during upload.
 * Multipart input is normalized before it is compared with these canonical values.
 */
export enum AssetTypeOverride {
  SCENE = 'scene',
  MOLD = 'mold',
}
